var React = require('react');

function ArrowUpInline (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"26.5","cy":"26.5","r":"24.5","transform":"rotate(-180 26.5 26.5)","fill":"#0A9E50","stroke":"#E1E8EC","strokeWidth":"4","key":0}),React.createElement("path",{"d":"M20.23 27.9145L25.3917 22.7529C26.0013 22.1433 26.9988 22.1433 27.6084 22.7529L32.77 27.9146","stroke":"white","strokeWidth":"1.5","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

ArrowUpInline.defaultProps = {"width":"54","height":"54","viewBox":"0 0 53 53","fill":"none"};

module.exports = ArrowUpInline;

ArrowUpInline.default = ArrowUpInline;
